import React from 'react';
import PropTypes from 'prop-types';

const Dashboard = ({ color, width, height, ariaLabel }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    aria-labelledby="title"
  >
    <title id="title">{ariaLabel}</title>
    <g
      fill="none"
      fillRule="evenodd"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 2H23V19H1zM7 22L17 22" />
      <path d="M13 10L23 10" transform="rotate(90 18 10)" />
      <path d="M8.5 11.5L15.5 11.5" transform="rotate(90 12 11.5)" />
      <path d="M4 13L8 13" transform="rotate(90 6 13)" />
    </g>
  </svg>
);

Dashboard.defaultProps = {
  ariaLabel: '',
};

Dashboard.propTypes = {
  ariaLabel: PropTypes.string,
  color: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default Dashboard;
